var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6888 23.8664H41.4V23.8H27V30.2H36.0424C34.7232 33.9256 31.1784 36.6 27 36.6C21.6984 36.6 17.4 32.3016 17.4 27C17.4 21.6984 21.6984 17.4 27 17.4C29.4472 17.4 31.6736 18.3232 33.3688 19.8312L37.8944 15.3056C35.0368 12.6424 31.2144 11 27 11C18.164 11 11 18.164 11 27C11 35.836 18.164 43 27 43C35.836 43 43 35.836 43 27C43 25.9272 42.8896 24.88 42.6888 23.8664Z",
    fill: "#FBC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8447 19.5528L18.1015 23.408C19.5239 19.8864 22.9687 17.4 26.9999 17.4C29.4471 17.4 31.6735 18.3232 33.3687 19.8312L37.8943 15.3056C35.0367 12.6424 31.2143 11 26.9999 11C20.8543 11 15.5247 14.4696 12.8447 19.5528Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 42.9997C31.1327 42.9997 34.8879 41.4181 37.7271 38.8461L32.7751 34.6557C31.1687 35.8725 29.1719 36.5997 26.9999 36.5997C22.8383 36.5997 19.3047 33.9461 17.9735 30.2429L12.7559 34.2629C15.4039 39.4445 20.7815 42.9997 26.9999 42.9997Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6888 23.8664L42.676 23.8H41.4H27V30.2H36.0424C35.4088 31.9896 34.2576 33.5328 32.7728 34.6568L32.7752 34.6552L37.7272 38.8456C37.3768 39.164 43 35 43 27C43 25.9272 42.8896 24.88 42.6888 23.8664Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.05e67cf72306b179e0cd916ce5e7043c.svg";
export { ForwardRef as ReactComponent };